import { makeStyles } from '@surveycake/rc';

export const useStyles = makeStyles([
  [
    'passwordForm',
    `
		display: flex;
		flex-direction: column;
		width: 300px;
		max-width: 100%;
		margin: 20px auto;
	`
  ],
  [
    'passwordInput',
    theme => `
		font-size: 24px;
		color: ${theme.color.primary.default};
		border-radius: 4px;
		border: 2px solid ${theme.survey.option.default.border.color};
		margin-bottom: 20px;
		padding: 6px 12px;
		outline: none;
		text-align: center;
	`
  ]
]);
